if (!customElements.get('rt-navigation-search')) {
  customElements.define('rt-navigation-search', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.form = this.closest('form');
      this.input = this.form?.querySelector('input[type="search"]');
      if (!this.input) return;
      const update = () => { this.hidden = this.input.value.trim().length > 0; };
      this.input.addEventListener('input', update, { signal: this.controller.signal });
      this.form.addEventListener('reset', () => queueMicrotask(update), { signal: this.controller.signal });
      this.closest('details')?.addEventListener('toggle', update, { signal: this.controller.signal });
      update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
if (!customElements.get('rt-navigation-header')) {
  customElements.define('rt-navigation-header', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      this.wrapper = this.closest('[data-rt-transparent-header]');
      this.section = this.closest('.section-header');
      if (!this.wrapper || !this.section) return;
      this.section.classList.add('rt-navigation-overlay');
      const update = () => {
        this.section.style.setProperty('--rt-navigation-height', `${this.wrapper.offsetHeight}px`);
        const atTop = window.scrollY < 10;
        this.wrapper.classList.toggle('rt-navigation-transparent-active', atTop && !this.wrapper.querySelector('details[open]'));
      };
      this.observer = new ResizeObserver(update);
      this.observer.observe(this.wrapper);
      window.addEventListener('scroll', update, { passive: true, signal: this.controller.signal });
      this.wrapper.addEventListener('toggle', update, { capture: true, signal: this.controller.signal });
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.section?.classList.remove('rt-navigation-overlay');
      this.wrapper?.classList.remove('rt-navigation-transparent-active');
      this.section?.style.removeProperty('--rt-navigation-height');
    }
  });
}
if (!customElements.get('rt-navigation-controls')) {
  customElements.define('rt-navigation-controls', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      const wrapper = this.closest('.header-wrapper');
      if (!wrapper) return;
      wrapper.dataset.rtPresentation = this.dataset.presentation || 'icons';
      wrapper.dataset.rtCartStyle = this.dataset.cartStyle || 'bag';
      wrapper.style.setProperty('--rt-featured-link-color', this.dataset.featuredColor || 'currentColor');
      const featured = new Set((this.dataset.featuredLinks || '').split(',').map(s => s.trim()).filter(Boolean));
      wrapper.querySelectorAll('.header__inline-menu a, .header__inline-menu summary, .menu-drawer__menu a, .menu-drawer__menu summary').forEach(link => {
        link.classList.toggle('rt-navigation-featured-link', featured.has(link.textContent.trim()));
      });
      const cart = wrapper.querySelector('#cart-icon-bubble');
      const template = this.querySelector('[data-cart-presentation]');
      if (cart && template) {
        const restore = () => {
          if (!cart.querySelector('[data-rt-cart-presentation]')) cart.append(template.content.cloneNode(true));
        };
        restore();
        this.observer = new MutationObserver(restore);
        this.observer.observe(cart, { childList: true });
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
if (!customElements.get('rt-navigation-quick-links')) {
  customElements.define('rt-navigation-quick-links', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.sync = () => {
        const source = this.querySelector('[data-rt-quick-links-source]');
        const target = document.querySelector('[data-rt-mobile-quick-links]');
        if (!source || !target) return;
        this.copy ||= document.createElement('div');
        this.copy.replaceChildren(source.cloneNode(true));
        this.copy.querySelector('ul').removeAttribute('data-rt-quick-links-source');
        target.append(this.copy);
      };
      document.addEventListener('shopify:section:load', this.sync, { signal: this.controller.signal });
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.sync, { once: true, signal: this.controller.signal });
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.copy?.remove();
    }
  });
}
